<template>
  <a v-if="showAd" :href="this.pickupitem.link_url" target="_blank" :data-ad="this.pickupitem.id" :data-sponsor="this.pickupitem.sponsor_name" :id="'ad-'+ this.placeText[parseInt(this.place,10)]">
    <img :src="this.pickupitem.image_url" :alt="this.pickupitem.title">
    <div class="spinner_area">
      <pulse-loader :loading="isLoading" :color="'#ff6969'" :size="'12px'"></pulse-loader>
    </div>
  </a>
</template>

<script>

export default {
  data () {
    return {
      showAd:false,
      items: [],
      requested: false,
      isLoading: false,
      pickupitem: [],
      placeText:['','top','bottom','searchtop','searchbottom'],
    }
  },
  props: {
    place: {
      type:String,
      default:"1",//1:top,2:bottom,3:searchtop,4:searchbottom
    },
    held: {
      type:Boolean,
      default:true,
    },
    public: {
      type:Boolean,
      default:false,//true で非公開のものを表示
    },
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      const data = {
        is_held: this.held,
        is_public: this.public,
        place: this.place,
      };
      var self = this;
      axios
        .post("/api/banners", data)
        // 成功時処理
        .then(res => {
          self.requested = true;
          self.isLoading = false;
          self.items = self.items.concat(res.data.items);
          self.pickupitem = this.getRandomArr(self.items);
          // データがあれば表示を実行
          if(res.data.total_count) {
            self.showAd = true;
            //かつメニューにバナーを追加
            /*if(this.place == "1" || this.place == "3" ){
              this.setAdForMenu();
            }*/
          }
        })
        // エラーレスポンス時処理
        .catch(error => {
          self.requested = true;
          self.isLoading = false;
          console.log(error);
        });
    },
    getRandomArr(arg) {
      return arg[Math.floor(Math.random() * arg.length)];
    },
    get(arg) {
      return arg[Math.floor(Math.random() * arg.length)];
    },
    setAdForMenu() {
      //バナーを加える
      var datalist = ' data-ad="' + this.pickupitem.id + '" data-sponsor="' + this.pickupitem.sponsor_name + '" id="ad-'+ this.placeText[parseInt(this.place,10)] + '"';
      var bannerEl = '<a href="' + this.pickupitem.link_url + '" target="_blank"' + datalist + '><img src="' + this.pickupitem.image_url + '" alt="' + this.pickupitem.title + '"></a>';
      var target = document.getElementById('menu_list');
      var insertEl = '<li class="ad_area ad_area_pc">' + bannerEl + '</li>';
      target.insertAdjacentHTML('beforeend', insertEl);
    },
  },
  created() {
    this.getPosts();
  },
}
</script>